module MySms
{
    declare var Stripe: any;
    declare var StripePublicKey: string;

    RequireLogin(() => InitializeSmsView());

    function InitializeSmsView() {
        $("#SmsLeft").html(webUser.smsBalance.toString());
        $("#SmsSent").html(webUser.smsSent.toString());

        let latestSmsPackage = GetNewestSmsPurchase(webUser.payments);
        if (latestSmsPackage != undefined)
            $("#LastSmsPurchase").html(DateToDateYearString(latestSmsPackage.purchaseTime));
        else
            $("#LastSmsPurchase").html("n/a");

        var hasCard = webUser.subscriptionType == CustomerAPI.PaymentType.Stripe && webUser.paymentCardNumber != null && webUser.paymentCardNumber.length > 0;
        if (hasCard)
            document.getElementById("smsList").getElementsByClassName("StartSub")[0].classList.remove("hidden");
        else
            document.getElementById("smsList").getElementsByClassName("StartSub")[0].remove();

    }

    function GetNewestSmsPurchase(payments: CustomerAPI.WebPayment[]): CustomerAPI.WebPayment {
        let newestPayment: CustomerAPI.WebPayment = undefined;
        for (var i = 0; i < payments.length; i++) {
            if (payments[i].product == CustomerAPI.Product.SmsPackage && payments[i].isPaymentCompleted
                && (newestPayment == undefined || payments[i].purchaseTime > newestPayment.purchaseTime))
            {
                newestPayment = payments[i];
            }
        }

        return newestPayment;
    }

    export function PurchaseSmsPackage()
    {
        Alert.OpenBuy(localizer["PurchaseSmsHeader"], localizer["PurchaseSmsBody"], confirm => {
            if (confirm) {
                let purchase = new CustomerAPI.WebPurchase();
                purchase.amount = 1;
                purchase.product = CustomerAPI.Product.SmsPackage;
                CustomerAPI.paymentAPI.post(purchase, (paymentResult: CustomerAPI.PaymentIntentResult) => {
                    if (paymentResult.status == CustomerAPI.PaymentIntentStatus.Success) {
                        Alert.OpenSuccess(localizer["PurchaseSmsSuccessHeader"], localizer["PurchaseSmsSuccessBody"], () => location.reload());
                    } else if (paymentResult.status == CustomerAPI.PaymentIntentStatus.RequiresAction) {
                        var stripe = Stripe(StripePublicKey);
                        stripe.handleCardPayment(paymentResult.clientSecret, { payment_method: paymentResult.paymentMethodId })
                            .then((stripeResult: any) => {
                                if (stripeResult.error) {
                                    Alert.OpenError(localizer["ErrorHeaderBuySms"], stripeResult.error);
                                } else {
                                    purchase.paymentIntentId = stripeResult.paymentIntent.id;
                                    CustomerAPI.paymentAPI.post(purchase,
                                        ((finalResult: CustomerAPI.PaymentIntentResult) => {
                                            if (finalResult.status == CustomerAPI.PaymentIntentStatus.Success) {
                                                Alert.OpenSuccess(localizer["PurchaseSmsSuccessHeader"], localizer["PurchaseSmsSuccessBody"], () => location.reload());
                                            } else {
                                                Alert.OpenError(localizer["ErrorHeaderBuySms"], "");
                                            }
                                        }), (ex, reason) => {
                                            Alert.OpenError(localizer["ErrorHeaderBuySms"], ex)
                                        });
                                }
                            });
                    }
                    
                }, (ex, reason) => Alert.OpenError(localizer["ErrorHeaderBuySms"], ex));
            }
        });
    }
}